import { render, staticRenderFns } from "./thirdOrderList.vue?vue&type=template&id=3ef277d4&scoped=true"
import script from "./thirdOrderList.vue?vue&type=script&lang=js"
export * from "./thirdOrderList.vue?vue&type=script&lang=js"
import style0 from "./thirdOrderList.vue?vue&type=style&index=0&id=3ef277d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef277d4",
  null
  
)

export default component.exports